import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'

import { media } from '../../../styles/utils'
import { container, bgIcon, padding, hoverState, bgImage } from '../../../styles/global'
import { ribbon, grey } from '../../../styles/colors';
import { pullQuote } from '../../../styles/type';

class BlockPullQuote extends React.Component {

	state = {
	
	}
	
	render() {
        const { pullquote } = this.props;
        
		return (
            <Text
                dangerouslySetInnerHTML={{__html: pullquote}}  
            />
		)
	}
}


const Text = styled.div`
	${pullQuote};
	width: 680px;
	max-width: 100%;

	${media.laptop`
		width: 534px;
	`}

	${media.tablet`
		width: 460px;
	`}
`
BlockPullQuote.wrapper = css`
	display: flex;
	justify-content: center;
	${padding};
	/* override base block styles */
	margin-bottom: 30rem!important;
	padding-top: 20rem!important;

	${media.phone`
		margin-bottom: 20rem!important;
		padding-top: 10rem!important;
	`}

	&:first-child {
		padding-top: 30rem!important;

		${media.phone`
			padding-top: 20rem!important;
		`}
	}
`

export default BlockPullQuote



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockPullQuote.js